// extracted by mini-css-extract-plugin
export default {"hero":"style_hero__ppGLA","content":"style_content__OlsGW","textInfo":"style_textInfo__N9KqD"};